// extracted by mini-css-extract-plugin
export default {"photoContainer":"property_photo_photoContainer__a7mcQ","picture":"property_photo_picture__zY-in"};